<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="12" lg="6">
                <el-text-field
                  label="Sistemos pranešimo pavadinimas"
                  v-model="mainData['title-search-like']"
                  hide-details
                  :maxlength="200"
                />
              </v-col>
              <v-col cols="12" md="12" lg="6">
                <el-autocomplete
                  :items="enumsClassifiers.application"
                  enums
                  multiple
                  itemvalue="value"
                  itemtext="text"
                  hide-details
                  label="Pranešimas rodomas"
                  v-model="mainData['applications-search-custom']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" >
                <el-date-picker
                  label="Pranešimo rodymo data (ribojimas nuo) nuo"
                  v-model="mainData['valid_from-search-from']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" >
                <el-date-picker
                  label="Pranešimo rodymo data (ribojimas nuo) iki"
                  v-model="mainData['valid_to-search-to']"
                />
              </v-col>
              <v-col class="pt-1" cols="12" md="6" lg="3">
                <el-text-field
                  label="Kodas"
                  v-model="mainData['code-search-like']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminSystemNotificationsSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    this.searchData()
  },
  methods: {
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = { isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData(true)
        } 
      })
    },
  },
}
</script>
